import { Button, Card, Col, Form, Modal, Space, Spin, Table } from 'antd'
import React, { useState } from 'react'
import ValidatorHelper from '../helpers/ValidatorHelper'
// import DatePicker from 'react-datepicker2'
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import moment from 'moment-jalaali'
import { useReportsStore } from '../../store/slices/createReportsSlice'
import { ZoomInOutlined } from '@ant-design/icons';

const PlaqueReport = () => {

    const reports = useReportsStore()
    const data = reports.plaqueReoprt.data
    const loading = reports.plaqueReoprt.loading
    const singleLoading = reports.plaqueReoprt.singlePlaqueReport.loading
    const [, setRequestId] = useState();
    const [visible, setVisible] = useState(false);
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);

    const details = reports.plaqueReoprt.singlePlaqueReport.data

    const columns = [
        {
            title: "جزئیات",
            dataIndex: "operation",
            key: "operation",
            width: 85,
            render: (_, record) =>
                data.length >= 1 && (
                    <Space size="middle">
                        <Button type='link' onClick={() => {
                            reports.getPlaqueReport(record.ResultOfCentralInsuranceInquiryId);
                            setRequestId(record.Id);
                            setVisible(true);
                        }
                        }><ZoomInOutlined /></Button>
                    </Space>
                ),
        },
        {
            title: "شناسه",
            dataIndex: "Id",
            key: "Id",
        },
        {
            title: "تاریخ ایجاد",
            dataIndex: "CreationTime",
            key: "CreationTime",
            render: (text) => {
                // Convert to Persian date format
                return moment(text).format('jYYYY/jMM/jDD HH:mm:ss');
            }
        },
        {
            title: "کد ایران",
            dataIndex: "IranCode",
            key: "IranCode",
        },
        {
            title: "کد ملی",
            dataIndex: "NationalCode",
            key: "NationalCode",
        },
        {
            title: "شناسه استعلام بیمه مرکزی",
            dataIndex: "ResultOfCentralInsuranceInquiryId",
            key: "ResultOfCentralInsuranceInquiryId",
        },
        {
            title: "پلاک",
            dataIndex: "StringPlaque",
            key: "StringPlaque",
        },
        {
            title: "موفق",
            dataIndex: "Success",
            key: "Success",
            render: (_, record) => {
                const successKey = Object.keys(record).find(key => key.toLowerCase() === 'success');

                if (successKey) {
                    const successValue = record[successKey];

                    if (typeof successValue === 'boolean') {
                        return successValue ?
                            <span style={{ color: 'green' }}>بله</span> :
                            <span style={{ color: 'red' }}>خیر</span>;
                    } else {
                        return String(successValue);
                    }
                }

                return '-';
            }
        }

    ]

    function convertToMoment(date) {
        return moment(date?.toDate()).format("YYYY-MM-DD");
    }


    function onFinish(values) {

        // const fromDate = moment(values.fromDate).format('YYYY-MM-DD')
        // const toDate = moment(values.toDate).format('YYYY-MM-DD')

        reports.getPlaquesReport({
            fromDate: convertToMoment(fromDate),
            toDate: convertToMoment(toDate)
        });
    }

    return (
        <div>
            <Card>
                <Col style={{
                    display: "flex",
                    gap: 20,
                    marginBottom: 16,
                    justifyContent: "space-between",
                    alignItems: "center"
                }} xs={24}>
                    <div style={{ fontSize: 16 }}>گزارش استعلام پلاک</div>
                </Col>
                <div style={{ fontSize: 14, marginBottom: 16 }}>بازه تاریخی مربوطه را انتخاب کنید</div>
                <Form
                    onFinish={onFinish}
                    layout="inline"
                >
                    <Form.Item
                        rules={ValidatorHelper.required("تاریخ")}
                        style={{ width: "220px" }}
                        name='fromDate'
                        label='از تاریخ'>
                        <DatePicker
                            value={fromDate}
                            onChange={setFromDate}
                            calendar={persian}
                            locale={persian_fa}
                            format="YYYY/MM/DD"
                            inputClass="datepicker-input"
                            calendarPosition="bottom-right"
                            portal
                            zIndex={1070}
                        />
                    </Form.Item>
                    <Form.Item
                        rules={ValidatorHelper.required("تاریخ")}
                        style={{ width: "220px" }}
                        name='toDate'
                        label='تا تاریخ'>
                        <DatePicker
                            value={toDate}
                            onChange={setToDate}
                            calendar={persian}
                            locale={persian_fa}
                            format="YYYY/MM/DD"
                            inputClass="datepicker-input"
                            calendarPosition="bottom-right"
                            portal
                            zIndex={1070}
                        />
                    </Form.Item>
                    <button
                        style={{
                            float: "left",
                            padding: "0 17px",
                            height: 33,
                        }}
                        loading={loading}
                        disabled={loading} type="primary" className="btn btn-primary waves-effect waves-light" htmltype="submit">
                        جستجو&nbsp;&nbsp;&nbsp; <i className={loading ? "bx bx-loader bx-spin" : "fas fa-search"}></i>
                    </button>

                    {/* {data?.length > 0 && userInfoResources && userInfoResources?.includes("BusinessAdmin") && <Col style={{ marginRight: "auto", marginLeft: 18 }} xs={3}>
                    <div style={{ whiteSpace: "nowrap" }}>
                        {<div style={{ cursor: "pointer" }} onClick={downloadxlsx} className="btn-success border-0 rounded ml-auto pb-2 pt-2 pr-3 pl-3 mr-2 mb-2"> <i className="far fa-file-excel font-size-14 align-middle mr-2"></i>دریافت اکسل</div>}
                    </div>
                </Col>} */}

                </Form>
                <div>
                    <Table
                        style={{ overflowX: 'scroll' }}
                        size="small"
                        className="custom-table"
                        loading={loading}
                        bordered
                        rowKey="ReportDate"
                        columns={columns}
                        dataSource={data}
                    />
                    <Modal
                        width={900}
                        title="جزئیات استعلام پلاک"
                        className="custom-table"
                        visible={visible}
                        footer={false}
                        onCancel={() => setVisible(false)}>
                        <Spin spinning={singleLoading}>
                            {details ? (
                                <pre style={{ direction: 'ltr', textAlign: 'left', maxHeight: '500px', overflow: 'auto' }}>
                                    {typeof details === 'string' ? details : JSON.stringify(details, null, 2)}
                                </pre>
                            ) : (
                                <div className="text-center">
                                    <p>اطلاعاتی برای نمایش وجود ندارد</p>
                                </div>
                            )}
                        </Spin>
                    </Modal>


                </div>
            </Card>
        </div>
    )
}

export default PlaqueReport
